import store from '../../store/index';

export default function redirectTo(to, from) {
  store.dispatch('setAwaitingNavigation', true);
  window.history.pushState({}, null, from);
  window.location.replace(to);
}
